module.exports = __webpack_public_path__ + "img/edit-icon.2ccb9e77.png";